import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  TemplateRef,
  output
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";


/**
 * @deprecated Ce visuel est désormais celui des alertes, qui ne sont plus utilisés
 * dans le flux d'une page : pour une alerte, passer par le composant snack
 * (`SnackSuccessComponent` / `SnackErrorComponent`). Pour un message contextuel
 * affiché dans une section de l'écran, utiliser `MessageContextuelComponent`
 * (`lib-pegase-message-contextuel`).
 */
@Component({
  selector: 'lib-pegase-alert',
  templateUrl: './pcscol-alert.component.html',
  styleUrls: ['./pcscol-alert.component.scss'],
  imports: [
    NgClass,
    NgTemplateOutlet,
    MatIconModule
  ],
  standalone: true
})
export class PcscolAlertComponent {
    @Input() type!: "success"|"info"|"warning"|"error";
    @Input() hasClosedButton = false;
    @Input() message!: string
    @Input() messageTemplate!: TemplateRef<any>;
    @Input() disablePreMessage?: boolean = false;

    readonly closedEvent = output<any>();

    @ViewChild('alertElement', {static: true}) private alertElement!: ElementRef;

    close() {
        this.closedEvent.emit(null);
        this.alertElement.nativeElement.remove();
    }
}
